class ShareWidget extends HTMLElement {
  constructor() {
    super();

    this.details = this.querySelector("details");
    this.copy = this.querySelector("[data-share-copy]");
    this.copyText = this.copy.querySelector("span");

    this.handleOutsideClick = (e) => {
      if (this.contains(e.target)) return;

      this.details.open = false;
    };

    window.addEventListener("click", this.handleOutsideClick);

    this.copy.addEventListener("click", () => {
      navigator.clipboard?.writeText(this.copy.dataset.shareCopy);
      const oldValue = this.copyText.innerHTML;
      this.copyText.innerHTML = "Copied!";

      setTimeout(() => {
        this.copyText.innerHTML = oldValue;
      }, 2000);
    });
  }

  disconnectedCallback() {
    window.removeEventListener("click", this.handleOutsideClick);
  }
}

if (!customElements.get("share-widget")) {
  customElements.define("share-widget", ShareWidget);
}
